export default __webpack_public_path__ + "static/media/chabad.6f02f277.svg";